<div class="dialog-container" id="kudos-dialog">
  <div class="dialog-header">
    <mat-icon class="kudos-title-icon">favorite</mat-icon>
    <h2 mat-dialog-title class="kudos-title">
      {{ 'kudos.title' | transloco }}
    </h2>
  </div>

  <mat-dialog-content class="dialog-content">
    @if (loading()) {
      <div class="loading-state">
        <mat-icon class="spin-icon">refresh</mat-icon>
        <p>{{ 'kudos.loading' | transloco }}</p>
      </div>
    } @else if (error()) {
      <div class="error-state">
        <mat-icon color="error">error</mat-icon>
        <p>{{ 'kudos.error' | transloco }}</p>
      </div>
    } @else {
      <mat-nav-list class="kudos-list">
        @for (item of kudosItems(); track item.title) {
          <a
            mat-list-item
            class="kudos-item"
            tabindex="0"
            lines="2"
            (click)="openUrl(item.url)"
            (keydown.enter)="openUrl(item.url)">
            <div matListItemIcon class="item-visual">
              @if (item.avatar) {
                <div class="avatar-container">
                  <div class="avatar-image-wrapper">
                    <img
                      class="item-avatar"
                      referrerpolicy="no-referrer"
                      [src]="item.avatar"
                      [alt]="item.title"
                      (error)="handleImageError(item)" />
                  </div>
                  @if (item.icon) {
                    <mat-icon class="avatar-icon-overlay">
                      {{ item.icon }}
                    </mat-icon>
                  }
                </div>
              } @else {
                <div class="acronym-avatar">
                  {{ item.initials }}
                  @if (item.icon) {
                    <mat-icon class="avatar-icon-overlay small">
                      {{ item.icon }}
                    </mat-icon>
                  }
                </div>
              }
            </div>
            <span matListItemTitle class="item-title">
              {{ item.title }}
            </span>
            <span matListItemLine class="item-subtitle">
              {{ item.subtitle }}
            </span>
            <mat-icon matListItemMeta>open_in_new</mat-icon>
          </a>
        }
      </mat-nav-list>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="close()">
      {{ 'common.close' | transloco }}
    </button>
  </mat-dialog-actions>
</div>
